import 'bootstrap/dist/css/bootstrap.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '../node_modules/nprogress/nprogress.css'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import VStep from './components/VStep.vue'
import VTour from './components/VTour.vue'

const VueTour = {
    install(app, options) {
        if (!options) {
            options = {}
        }

        app.component(VTour.name, VTour)
        app.component(VStep.name, VStep)

        app.config.globalProperties.$tours = {}
    }
}

//createApp(App).use(router).mount('#app')

const app = createApp(App);

app.config.productionTip = false;

app.use(router);
app.use(VueToast);
app.use(VueTour);

app.component('tour-steps', {
    props: ['tour'],
    template: `
     <div>
       <div v-for="(step, index) of tour.steps" :key="index">
       <v-step
               v-if="tour.currentStep === index"
               :step="step"
               :previous-step="tour.previousStep"
               :next-step="tour.nextStep"
               :stop="tour.stop"
               :is-first="tour.isFirst"
               :is-last="tour.isLast"
               :labels="tour.labels"
               :highlight="tour.highlight">
         <template v-if="tour.currentStep === 2">
           <div slot="actions">
             <button @click="tour.previousStep" class="btn btn-primary mr-2">Previous step</button>
             <button @click="tour.nextStep" class="btn btn-primary">Next step</button>
           </div>
         </template>
       </v-step>
     </div>
     </div>`
});

var vm = app.mount("#app");

export { app, vm }

export default VueTour

//createApp(App).mount('#app')